import ResearchPage from '../../modules/ResearchPage/ResearchPage';

function ResearchLayout() {
  return (
    <div>
      <ResearchPage />
    </div>
  );
}

export default ResearchLayout;

